<template>
  <div>
    <v-select
      :items="comparadores"
      label="Ultimo acesso"
      item-text="text"
      item-value="value"
      v-model="comparadorSelecionado"
    />
    <div v-show="showDatePicker">
      <v-menu
        v-model="da"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataUltimoAcesso"
            label="Data Ultimo Acesso"
            prepend-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker no-title @input="selecionarDataUltimoAcesso" />
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroUltimoAcesso',
  data() {
    const hoje = new Date().toLocaleDateString()
    return {
      da: false,
      dataUltimoAcesso: hoje,
      comparadores: [
        {
          text: 'Não comparar',
          value: null
        },
        {
          text: 'Nunca acessou',
          value: 'x'
        },
        {
          text: 'Ultimo acesso antes de',
          value: '<'
        },
        {
          text: 'Ultimo acesso depois de',
          value: '>'
        }
      ],

      dataUltimoAcessoSelecionada: this.parseData(hoje),
      comparadorSelecionado: null
    }
  },
  computed: {
    tudo() {
      return `${this.dataUltimoAcessoSelecionada}|${this.comparadorSelecionado}`
    },
    showDatePicker() {
      return this.comparadorSelecionado !== null && this.comparadorSelecionado !== 'x'
    }
  },
  watch: {
    tudo() {
      this.$emit('filtrar-ultimo-acesso', {
        data_ultimo_acesso: this.dataUltimoAcessoSelecionada,
        comparador_ultimo_acesso: this.comparadorSelecionado
      })
    }
  },
  methods: {
    parseData(data) {
      let [dia, mes, ano] = data.split('/')
      return `${ano}-${mes}-${dia}`
    },
    selecionarDataUltimoAcesso(value) {
      this.dataUltimoAcesso = this.toDate(value).toLocaleDateString()
      this.dataUltimoAcessoSelecionada = value
      this.dc = false
    },
    toDate(value) {
      return new Date(value + 'T00:00')
    }
  }
}
</script>
